export enum ManualTaskPlanningResourceType {
  Other = "Other",
  Room = "Room",
  Hardware = "Hardware",
  Software = "Software",
}
